var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popup-package" }, [
    _vm.type == 1
      ? _c("div", { staticClass: "dialog_box" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("p", [
            _c("span", { on: { click: _vm.close_applets } }, [_vm._v("取消")]),
            _vm._v(" "),
            _c("span", { staticClass: "goapp" }, [
              _vm.data
                ? _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://www.eoffcn.com/zg_jiaoyu/detail?orderSn=" +
                          _vm.data.order_id +
                          "&package_id=" +
                          _vm.data.package_id +
                          "&cid=" +
                          _vm.data.cid +
                          "&menu_id=" +
                          _vm.data.menu_id +
                          "&spuID=" +
                          _vm.data.shopid +
                          "&owner=" +
                          _vm.owner +
                          "&channel=" +
                          _vm.channel +
                          "&orgn=" +
                          _vm.orgn +
                          "&channelId=225"
                      }
                    },
                    [_vm._v("去APP查看\n        ")]
                  )
                : _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "https://www.eoffcn.com/zg_jiaoyu/detail?channelId=225"
                      }
                    },
                    [_vm._v("去APP查看\n        ")]
                  )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type == 2
      ? _c("div", { staticClass: "open_applets_box" }, [
          _c("div", { staticClass: "open_applets" }, [
            _c("p", { staticClass: "tip_qrcode" }, [
              _vm._v(
                "小程序中暂不支持查看该课件，你可下载“中公教育”APP进行查看"
              )
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "qrcode_img",
              attrs: { src: require("../../../static/images/qrcode_offcn.png") }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: {
                id: "copytext",
                type: "text",
                value: "https://www.eoffcn.com/zg_jiaoyu/detail"
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "copy_name", on: { click: _vm.copy_applets } },
              [_vm._v("复制下载链接")]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "save_qrcode" }, [
              _vm._v("长按保存二维码，扫码下载APP或使用浏览器打开下载链接")
            ])
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: { src: require("../../../static/images/shut.png") },
            on: { click: _vm.close_applets }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dialog_message" }, [
      _vm._v("手机浏览器暂不支持查看该课件"),
      _c("br"),
      _vm._v('你可在"中公教育"APP进行查看')
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17c1444f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c1444f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/index.vue
// module id = null
// module chunks = 